import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4681852d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  height: "7",
  "aria-orientation": "horizontal",
  class: "v-divider",
  theme: "light"
}, null, -1))
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = { class: "d-flex align-center justify-end ml-n16" }
const _hoisted_4 = { class: "position-amount-wrapper py-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider",
  theme: "light"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Belegnummer", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Positionsnummer", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Artikelnummer", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Chargenpflicht", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Seriennrpflicht", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Gruppenbezeichnung", -1))

import {ref, computed, watch} from 'vue';
import Picklist from '@/model/Picklist';
import BookingItem from './PositionItem/BookingItem.vue';
import {roundToOneOverX, doConfirm} from '@/util';
import {usePicklistPickerStore} from '@/store/picklistPickerV2';
import ScrollText from '@/components/ScrollText.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionItem',
  props: {
  positionIndex: {
    type: Number,
    required: true,
  },
  picklist: {
    type: Picklist,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  deletable: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [Number, String],
    required: true,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
},
  emits: {
  deletePosition() {
    return true;
  },
  'update:modelValue'(val: boolean) {
    return typeof val === 'boolean';
  },
},
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emits = __emit;

const bookingModal = ref(false);
// TODO: automatisches Öffnen/Schließen

const picklistPicker = usePicklistPickerStore();
const position = computed(() => props.picklist.allPositions[props.positionIndex]);

const pickData = computed(() => {
  return picklistPicker.getPickData(position.value);
});
const pickedCount = computed(() => {
  return pickData.value?.bookings?.reduce((cum, b) => cum + b.qty, 0) ?? 0;
});

const pickedPercentage = computed(() => {
  return Math.round((pickedCount.value / position.value.Menge) * 100);
});

const bookings = computed(() => {
  return pickData.value?.bookings ?? [];
});

const bookingItems = computed((): Array<{ text: string | number | object, value: string | number | object }> => {
  return bookings.value.map(
      (b, i) => ({
        value: i,
        text: `Lager ${b.warehouse}${b.batchNo ? ` – Chargennummer ${b.batchNo}` : ''}${b.serialNo ? ` – Seriennummer ${b.serialNo}` : ''}`,
      }),
  );
});
const bookingIndex = computed((): number => {
  return bookings.value.length ? bookings.value.length - 1 : 0;
});
const booking = computed(() => {
  return picklistPicker.getBooking(position.value, bookingIndex.value);
});


const addBooking = async () => {
  try {
    if (picklistPicker.picklist?.BestellNr !== null && pickData.value.qty >= pickData.value.position.Menge && !await doConfirm('Diese Position ist bereits voll. Trotzdem Teilbuchung anlegen?', 'Bereits vorhanden')) throw new Error('Vorgang abgebrochen');
    picklistPicker.getBooking(position.value);
  } catch (err) {
    console.error(err);
  }
};
const deleteBooking = async (id: number) => {
  if (!await doConfirm(`Buchung #${id + 1} wirklich löschen?`, 'Wirklich löschen?')) return;
  picklistPicker.deleteBooking(position.value, id);
  if (bookings.value.length < 2) {
    // Modal schließen, wenn keine Buchungen mehr darin
    bookingModal.value = false;
  }
};

watch(computed(() => pickData.value.done), (done: boolean, oldDone: boolean) => {
  if (oldDone || !done) return;

  if (picklistPicker.selectedPosition === props.positionIndex) {
    picklistPicker.selectedPosition = null;
  }
});

const el = ref(null as HTMLDivElement | null);
let timeout: NodeJS.Timeout | null = null;
watch(() => props.expanded, async (expandedVal) => {
  if (timeout) clearInterval(timeout);
  if (expandedVal) {
    const itemEl = el.value?.querySelector('.v-list-group__items');
    let lastHeight = itemEl?.clientHeight ?? 0;
    timeout = setInterval(async () => {
      const itemEl = el.value?.querySelector('.v-list-group__items');
      if (itemEl?.clientHeight === 0) return;
      if (itemEl?.clientHeight !== lastHeight) {
        lastHeight = itemEl?.clientHeight ?? 0;
        return;
      }
      if (timeout) clearInterval(timeout);
      const appBar = document.getElementById('mainAppBar');
      const topOffset = (appBar?.clientHeight ?? 64);
      const scrollTop = (document.scrollingElement?.scrollTop ?? 0);
      const clientRectTop = el.value?.getBoundingClientRect().top ?? 0;
      const newPosition = clientRectTop - topOffset + scrollTop;
      window.scroll(0, newPosition);
      console.log('scrolled to', document.scrollingElement?.scrollTop);
    }, 50);
  }
});

function resetPosition() {
  picklistPicker.clearBookings(position.value);
}

function deletePosition() {
  emits('deletePosition');
}

__expose({
  BookingItem,
  bookingModal,
  position,
  pickData,
  pickedCount,
  pickedPercentage,
  bookings,
  bookingItems,
  bookingIndex,
  picklistPicker,
  booking,
  addBooking,
  deleteBooking,
  roundToOneOverX,
  resetPosition,
  deletePosition,
  el,
});


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_scroll_x_transition = _resolveComponent("v-scroll-x-transition")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_list_group = _resolveComponent("v-list-group")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el
  }, [
    _hoisted_1,
    _createVNode(_component_v_list_group, {
      class: "postition-group",
      "selected-class": "text-grey",
      value: __props.value
    }, {
      activator: _withCtx(({props}) => [
        (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
          class: "position-header pr-3",
          modelValue: pickData.value.done,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pickData.value.done) = $event)),
          key: `${position.value.Belegnr}-${position.value.Posnr}`
        }, props), {
          prepend: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_scroll_x_transition, null, {
                default: _withCtx(() => [
                  (pickData.value.done && pickData.value.overbooked)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "mr-2",
                        color: "warning"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" mdi-checkbox-marked-circle-plus-outline ")
                        ], undefined, true),
                        _: 1
                      }))
                    : (pickData.value.done && !pickData.value.overbooked)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          class: "mr-2",
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" mdi-checkbox-marked-circle-outline ")
                          ], undefined, true),
                          _: 1
                        }))
                      : (pickData.value.full)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 2,
                            class: "mr-2",
                            color: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" mdi-alert ")
                            ], undefined, true),
                            _: 1
                          }))
                        : (!pickData.value.valid || (pickData.value.qty <= 0 && __props.picklist.isSuggestion))
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 3,
                              class: "mr-2",
                              color: "error"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" mdi-alert-remove ")
                              ], undefined, true),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                ], undefined, true),
                _: 1
              })
            ])
          ]),
          append: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_chip, {
                  class: "position-amount",
                  size: "x-small",
                  variant: "outlined",
                  color: pickData.value.done ? ' lighten-4' : ''
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(pickData.value.done ? 'text-grey done' : '')
                    }, [
                      _createElementVNode("b", null, [
                        _createTextVNode(_toDisplayString(pickedCount.value ? pickedCount.value : '0'), 1),
                        (position.value.Menge)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("/" + _toDisplayString(position.value.Menge), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createTextVNode(" " + _toDisplayString(position.value.Einheit), 1)
                    ], 2)
                  ], undefined, true),
                  _: 1
                }, 8, ["color"]),
                (pickData.value?.qtyGebinde !== null)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "x-small",
                      variant: "outlined",
                      class: "position-amount ml-auto",
                      color: pickData.value.done ? 'grey-darken-1' : 'grey-darken-1'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(pickData.value.done ? 'text-grey done' : 'text-primary')
                        }, [
                          _createElementVNode("b", null, [
                            _createTextVNode(_toDisplayString(_unref(roundToOneOverX)(pickData.value?.qtyGebinde)), 1),
                            (position.value.Menge)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("/" + _toDisplayString(position.value.Gebindemenge), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createTextVNode(" " + _toDisplayString(position.value.Gebindeinh), 1)
                        ], 2)
                      ], undefined, true),
                      _: 1
                    }, 8, ["color"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_v_icon, {
                icon: __props.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }, null, 8, ["icon"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list_item_title, {
              class: _normalizeClass((pickData.value.done && 'text-grey done') || '')
            }, {
              default: _withCtx(() => [
                _createElementVNode("b", null, [
                  _createVNode(ScrollText, {
                    text: position.value.Bezeichn1,
                    disable: !__props.expanded
                  }, null, 8, ["text", "disable"])
                ])
              ], undefined, true),
              _: 1
            }, 8, ["class"]),
            (position.value.Bezeichn2)
              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(ScrollText, {
                      text: position.value.Bezeichn2,
                      disable: !__props.expanded
                    }, null, 8, ["text", "disable"])
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (pickData.value.bookings.length === 1)
              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                  key: 1,
                  class: "mx-n1"
                }, {
                  default: _withCtx(() => [
                    (pickData.value.bookings[0].batchNo && pickData.value.bookings[0].nve)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            class: "mx-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(pickData.value.bookings[0].batchNo), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            class: "mx-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(pickData.value.bookings[0].nve), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], 64))
                      : (pickData.value.bookings[0].nve)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            size: "x-small",
                            class: "mx-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(pickData.value.bookings[0].nve), 1)
                            ], undefined, true),
                            _: 1
                          }))
                        : (pickData.value.bookings[0].batchNo)
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 2,
                              size: "x-small",
                              class: "mx-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(pickData.value.bookings[0].batchNo), 1)
                              ], undefined, true),
                              _: 1
                            }))
                          : (pickData.value.bookings[0].serialNo)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 3,
                                size: "x-small",
                                class: "mx-1"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(pickData.value.bookings[0].serialNo), 1)
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 2
        }, 1040, ["modelValue"]))
      ]),
      default: _withCtx(() => [
        (bookings.value.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_v_dialog, {
                modelValue: bookingModal.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((bookingModal).value = $event)),
                fullscreen: "",
                scrollable: "",
                scrim: false
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    block: "",
                    size: "large",
                    class: "text-white rounded-0",
                    color: "blue-accent-2",
                    elevation: "0"
                  }), {
                    default: _withCtx(() => [
                      _createTextVNode(" +" + _toDisplayString(bookings.value.length - 1) + " Buchungen ", 1)
                    ], undefined, true),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    rounded: "0",
                    elevation: "0",
                    color: "grey-lighten-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar, {
                        theme: "dark",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_toolbar_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Weitere Buchungen")
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_v_toolbar_items, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                class: "rounded-0",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (bookingModal.value = false))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Schließen ")
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((bookings.value.length ? bookings.value.length - 1 : 0), (i) => {
                            return (_openBlock(), _createBlock(_component_v_card, {
                              key: i,
                              class: "mb-5"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_layout, {
                                      "d-flex": "",
                                      "justify-space-between": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, "Buchung #" + _toDisplayString(i), 1),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          variant: "flat",
                                          onClick: ($event: any) => (deleteBooking(i - 1)),
                                          color: "error"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "large" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-delete")
                                              ], undefined, true),
                                              _: 1
                                            })
                                          ], undefined, true),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ], undefined, true),
                                      _: 2
                                    }, 1024)
                                  ], undefined, true),
                                  _: 2
                                }, 1024),
                                _createVNode(BookingItem, {
                                  "booking-index": i - 1,
                                  picklist: __props.picklist,
                                  "position-index": __props.positionIndex,
                                  onResetPosition: resetPosition,
                                  onDeletePosition: deletePosition,
                                  deletable: __props.deletable,
                                  readonly: ""
                                }, null, 8, ["booking-index", "picklist", "position-index", "deletable"])
                              ], undefined, true),
                              _: 2
                            }, 1024))
                          }), 128))
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (booking.value)
          ? (_openBlock(), _createBlock(BookingItem, {
              key: 1,
              "booking-index": bookingIndex.value,
              picklist: __props.picklist,
              "position-index": __props.positionIndex,
              onResetPosition: resetPosition,
              onDeletePosition: deletePosition,
              deletable: __props.deletable
            }, null, 8, ["booking-index", "picklist", "position-index", "deletable"]))
          : _createCommentVNode("", true),
        (_unref(picklistPicker).picklist?.mayAddBooking)
          ? (_openBlock(), _createBlock(_component_v_card_text, {
              key: 2,
              class: "pt-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: addBooking,
                  class: "rounded-0",
                  block: "",
                  size: "large",
                  color: "secondary",
                  elevation: "0",
                  disabled: !booking.value.valid || booking.value.qty <= 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-plus")
                      ], undefined, true),
                      _: 1
                    }),
                    _createTextVNode(" Teilbuchung hinzufügen ")
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"])
              ], undefined, true),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createVNode(_component_v_list_item, { class: "px-0 bg-grey-lighten-4 remove-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, { class: "my-5 bg-grey-lighten-4" }, {
              default: _withCtx(() => [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_7,
                    _createElementVNode("td", null, _toDisplayString(position.value.Belegnr ? position.value.Belegnr : '–'), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_8,
                    _createElementVNode("td", null, _toDisplayString(position.value.Posnr), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_9,
                    _createElementVNode("td", null, _toDisplayString(position.value.Artikelnr), 1)
                  ]),
                  (position.value.ChargenpflichtBool)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("td", null, [
                          _createVNode(_component_v_chip, {
                            color: position.value.ChargenpflichtBool ? 'green' : 'red',
                            size: "small",
                            class: "px-1",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "white",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(position.value.ChargenpflichtBool ? 'mdi-check' : 'mdi-window-close'), 1)
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          }, 8, ["color"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (position.value.SeriennrpflichtBool)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("td", null, [
                          _createVNode(_component_v_chip, {
                            color: position.value.SeriennrpflichtBool ? 'green' : 'red',
                            size: "small",
                            class: "px-1",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "white",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(position.value.SeriennrpflichtBool ? 'mdi-check' : 'mdi-window-close'), 1)
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          }, 8, ["color"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _createElementVNode("td", null, _toDisplayString(position.value.GruppenBezeichnung), 1)
                  ])
                ])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["value"])
  ], 512))
}
}

})